import { Box } from "@primer/react";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { PlaceHolder } from "../../components/place-holder";
import { phuHuynhApi } from "../../api/phuHuynhApi";
import Modal from "../../components/ui/modal";
import CskhModalContent from "./cskh-modal-content";

interface PhuHuynhProfileProps {
  id: number;
  value?: number;
  height?: number;
  phuHuynh?: any;
  onClose: () => void;
  onSuccess: () => void;
}

const PhuHuynhProfile = (props: PhuHuynhProfileProps) => {
  const { id } = useParams<{ id: string }>();
  const [PhuHuynh, setPhuHuynh] = useState<any>({ id: props.id });
  const [isLoading, setIsLoading] = useState(false);
  const componentDidMount = useRef(false);

  useEffect(() => {
    setPhuHuynh({ id: props.value });
  }, [props.value, id]);

  useEffect(() => {
    componentDidMount.current = true;
    if (PhuHuynh.id > 0) {
      handleGetPhuHuynhData();
    }
    return () => {
      componentDidMount.current = false;
    };
  }, [PhuHuynh.id]);

  const handleGetPhuHuynhData = async () => {
    setIsLoading(true);
    const res = await phuHuynhApi.getById(PhuHuynh.id);
    if (!componentDidMount.current) return;
    setIsLoading(false);
    if (res.is_success) {
      setPhuHuynh(res.data);
    }
  };

  const subtitle = PhuHuynh?.ho_ten ? `Hồ sơ · ${PhuHuynh.ho_ten}` : undefined;

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      sx={{
        width: "80%"
      }}
      title={"Thông tin khách hàng"}
      subtitle={subtitle}
    >
      <Box p={0}>
        {isLoading && <PlaceHolder line_number={2} />}
        {!isLoading && (
          <CskhModalContent id={PhuHuynh.id} />
        )}
      </Box>
    </Modal>
  );
};

export default PhuHuynhProfile;
